import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/common/Button';
import Icon from '../../components/common/Icon';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: 'var(--bg)' }}>
      <div className="text-center max-w-md">
        <div className="mb-8">
          <h1 className="text-9xl font-bold" style={{ color: 'var(--primary)' }}>404</h1>
          <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--text)' }}>
            Page Not Found
          </h2>
          <p className="text-sm mb-8" style={{ color: 'var(--text-muted)' }}>
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        
        <div className="space-y-3">
          <Button
            variant="primary"
            onClick={() => navigate('/')}
            className="w-full"
          >
            Go to Homepage
          </Button>
          
          <Button
            variant="secondary"
            onClick={() => navigate(-1)}
            icon="arrowLeft"
            className="w-full"
          >
            Go Back
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
